import { Button } from '@bambi/component-library/src/components/Button/Button';
import { CloudArrowDownIcon } from '@heroicons/react/24/outline';
import { useEffect, useMemo } from 'react';

import { DriverMembershipFilter } from '../../../common/connectedFilters/DriverMembershipFilter';
import { fleetInspectionSlice } from './fleetInspection.slice';
import { useAppDispatch, useAppSelector } from 'src/app/store/hooks';
import DateRangeBadge from 'src/common/date/DateRangeBadge';

export function VehicleInspectionFilters() {
  const dispatch = useAppDispatch();
  const inspectionListFilter = useAppSelector(
    (state) => state.fleetInspection.inspectionListFilter
  );

  const isFiltered = useMemo(() => {
    return (
      !!Object.keys(inspectionListFilter).length &&
      !!Object.values(inspectionListFilter).some
    );
  }, [inspectionListFilter]);

  const handleDownload = () => {
    dispatch(fleetInspectionSlice.actions.setInspectionDownloadModal(true));
  };

  useEffect(() => {
    dispatch(fleetInspectionSlice.actions.initializeFilters());
  }, [dispatch]);

  return (
    <div className="flex flex-grow items-center gap-2">
      {isFiltered && (
        <Button
          onClick={() => dispatch(fleetInspectionSlice.actions.clearFilters())}
          variant="anchor"
          className="whitespace-nowrap"
        >
          clear filters
        </Button>
      )}
      {inspectionListFilter.rangeStart && inspectionListFilter.rangeEnd && (
        <DateRangeBadge
          from={inspectionListFilter.rangeStart}
          to={inspectionListFilter.rangeEnd}
          onClear={() =>
            dispatch(fleetInspectionSlice.actions.onClearDateFilter())
          }
        />
      )}
      <DriverMembershipFilter
        selected={inspectionListFilter.membershipIn || []}
        onChange={(value) => {
          dispatch(
            fleetInspectionSlice.actions.onDriverFilterChange(value.join(','))
          );
        }}
      />
      <Button onClick={handleDownload}>
        <CloudArrowDownIcon className="mr-2 h-5 w-5" /> Download
      </Button>
    </div>
  );
}
